/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ReturnIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ReturnIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ReturnIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ReturnIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 10"
 style={{'--as-1-ZFijFi': alignSelf,'--mt-2-ZFijFi': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZFijFi': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZFijFi': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZFijFi': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZFijFi': opacity,'--w-10-ZFijFi': typeof width === 'number' ? `${width}px` : width,'--h-11-ZFijFi': typeof height === 'number' ? `${height}px` : height,'--f-12-ZFijFi': fill,'--a-7-ZFijFi': isAnimated ? animation : "none",'--sd-8-ZFijFi': isAnimated ? strokeDashoffset : 0,'--sd-9-ZFijFi': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2ReturnIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M10.309 9.962A.5.5 0 0110 9.5v-2H4a4 4 0 01-4-4V1a1 1 0 112 0v2.5a2 2 0 002 2h6v-2a.5.5 0 01.854-.354l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.545.108z"
 style={{'--f-12-ZFijFi': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}